var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"fixed inset-0 bg-[#f0f4f7] text-white flex justify-center items-center"},[_c('v-progress-circular',{attrs:{"size":40,"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }